















































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import discountDialog from '../../../components/discountDialog.vue';
import PopUnifiedDiscountSettingsDialog from '@/views/wheelOfFortune/components/PopUnifiedDiscountSettingsDialog.vue';
import { isEnablePopUnifiedDiscountCode } from '@/utils/experiment';
import { getCompanyInfo } from '@/model/CompanyInfo';
import { WheelOption } from '@/model/FormWheel';
import InfoPopover from '@/views/wheelOfFortune/components/InfoPopover.vue';

@Component({
  name: 'WheelOptionsCollapse',
  components: {
    discountDialog,
    PopUnifiedDiscountSettingsDialog,
    'info-popover': InfoPopover,
  }
})
export default class WheelOptionsCollapse extends Vue {
  @Prop({ type: Array, required: true }) readonly value!: WheelOption[];
  @Prop({ type: Boolean, default: true }) readonly enableCouponSize!: boolean;

  activeNames: number[] = [];
  localOptions: WheelOption[] = [];

  // 动态折扣码对话框相关
  showDiscountDialog = false;
  currentDiscountIndex = -1;
  get discountValueTip() {
    return [this.$tx('form.discount.valueTip', '折扣值不在订阅工具用户侧展示，仅用于邮件变量。若邮件已勾选「优先使用用户之前通过订阅工具获取过的 Coupon Code 对应的折扣值」，请填写与折扣码对应的显示内容（如 15%）。')];
  }

  // 块颜色（按索引取色）
  blockColors: string[] = [
    '#FB4693', '#7A2DFF', '#30A8ED', '#4DD0B8', '#FF0000', '#818181', '#FFCA00', '#469C3D',
    '#8AD2C8', '#FE8157', '#673E12', '#803F56', '#D9A961', '#B8B8B8', '#EC6C6B', '#B0D8C7',
    '#EE5F31', '#498D80', '#97F5B2', '#21010C'
  ];

  created() {
    const incoming: any = Array.isArray(this.value) ? this.value : [];
    this.localOptions = this.withColors(this.clone(incoming));
    if (this.localOptions.length === 0) {
      this.localOptions.push({ color: this.getBlockColorByIndex(0), discountType: 1, coupon: '', couponSize: '' });
    }
    // 如果默认只有一块，自动展开第一块
    if (this.localOptions.length === 1) {
      this.activeNames = [0];
    }
  }

  get showDiscountSetting() {
    return sessionStorage.getItem('isShopify') === '1';
  }

  get customerApiEnabled() {
    return getCompanyInfo().customDiscountOpen === true;
  }

  /** 仅决定弹出哪种折扣码设置弹窗；入口/触发条件与线上一致 */
  get useUnifiedDiscountSettings() {
    return isEnablePopUnifiedDiscountCode();
  }

  get currentDiscountData() {
    if (this.currentDiscountIndex < 0) return null;
    return this.localOptions[this.currentDiscountIndex]?.discount || null;
  }

  get currentSourceType() {
    if (this.currentDiscountIndex < 0) return '';
    return this.localOptions[this.currentDiscountIndex]?.discountType === 3 ? 'CUSTOMER_SYSTEM' : '';
  }

  @Watch('value', { deep: true })
  onValueChange(v: WheelOption[]) {
    const incoming: any = Array.isArray(v) ? v : [];
    this.localOptions = this.withColors(this.clone(incoming));
    // 保底：至少 1 个占位，避免滑块处于 0 无法操作
    if (this.localOptions.length === 0) {
      this.localOptions = [{ color: this.getBlockColorByIndex(0), discountType: 2, coupon: '', couponSize: '', discount: null }];
      this.emitChange();
    }
    // 如果默认只有一块，自动展开第一块
    if (this.localOptions.length === 1) {
      this.activeNames = [0];
    }
  }

  onBlockCountChange(nextCount: any) {
    const target = Number(Array.isArray(nextCount) ? nextCount[0] : nextCount) || 1;
    const current = this.localOptions.length;
    if (target > current) {
      const toAdd = target - current;
      for (let i = 0; i < toAdd; i += 1) {
        const nextIndex = current + i;
        this.localOptions.push({ color: this.getBlockColorByIndex(nextIndex), discountType: 1, coupon: '', couponSize: '' });
      }
    } else if (target < current) {
      // 从末尾删除
      this.localOptions.splice(target);
    }
    window?.gtagClick('form_edit_setSlices','弹窗_编辑订阅工具_设置模版块数')
    this.emitChange();
  }

  emitChange() {
    // 确保浅拷贝，避免父级被意外引用
    const options = this.clone(this.localOptions).map((opt: WheelOption) => ({
      ...opt,
      couponSize: this.enableCouponSize ? (opt.couponSize || '') : ''
    }));
    this.$emit('input', options);
    this.$emit('change', options);
    console.log('emitChange', options);
  }

  toggle(idx: number) {
    const i = this.activeNames.indexOf(idx);
    if (i >= 0) {
      this.activeNames.splice(i, 1);
    } else {
      this.activeNames.push(idx);
    }
  }

  clone<T>(v: T): T {
    return JSON.parse(JSON.stringify(v));
  }

  onOptionsChange() {
    // 概率或角度变更时，同步回父组件
    this.emitChange();
  }

  onSetCoupon(index: number) {
    // 打开动态折扣码设置对话框
    this.currentDiscountIndex = index;
    this.showDiscountDialog = true;
  }

  onCouponTypeChange(index: number) {
    const opt = this.localOptions[index];
    if (opt.discountType === 1) {
      // 固定折扣码：清空动态折扣码配置
      opt.discount = null;
      opt.coupon = opt.coupon || '';
      opt.couponSize = opt.couponSize || '';
    } else if (opt.discountType === 2) {
      // 动态折扣码：清空固定折扣码；折扣值保留，供邮件折扣值变量使用
      opt.coupon = '';
      // 交互对齐：选中动态折扣码即弹出设置弹窗
      this.currentDiscountIndex = index;
      this.showDiscountDialog = true;
    }
    this.emitChange();
  }

  // 保存动态折扣码配置
  saveDiscount(discount: any) {
    console.log('saveDiscount', discount);
    if (this.currentDiscountIndex >= 0) {
      const opt = this.localOptions[this.currentDiscountIndex];
      opt.discount = discount;
      opt.coupon = ''; // 清空固定折扣码
      this.emitChange();
    }
    this.showDiscountDialog = false;
    this.currentDiscountIndex = -1;
  }

  // 关闭动态折扣码对话框
  closeDiscount() {
    this.showDiscountDialog = false;
    this.currentDiscountIndex = -1;
  }

  // 取块颜色
  getBlockColor(index: number): string {
    const opt: any = this.localOptions?.[index] || {};
    if (opt && typeof opt.color === 'string' && opt.color) return opt.color;
    return this.getBlockColorByIndex(index);
  }

  blockName(idx: number) {
    return this.$tx('form.edit.field.blockN', '块{{n}}', { n: idx + 1 });
  }

  blockWinning(opt: WheelOption) {
    return this.$tx('form.edit.field.blockWinning', '({{rate}}% winning)', { rate: opt.rate || 0 });
  }

  // 按索引从默认色板取色
  getBlockColorByIndex(index: number): string {
    if (!this.blockColors || this.blockColors.length === 0) return '#CCCCCC';
    const i = Math.abs(Number(index)) % this.blockColors.length;
    return this.blockColors[i];
  }

  // 为现有选项补齐颜色字段
  withColors(options: any[]): any[] {
    if (!Array.isArray(options)) return [];
    return options.map((opt, idx) => {
      const color = (opt && typeof opt.color === 'string' && opt.color) ? opt.color : this.getBlockColorByIndex(idx);
      return { ...(opt || {}), color };
    });
  }
}
